import { defineStore } from 'pinia'
import { ref } from 'vue'

// Top-bar header override for screens whose title is data, not a constant —
// a holding's property name, say. Routes still declare their static label via
// `meta.title` / `meta.eyebrow`; a screen sets this only when it has something
// more specific, and clears it on the way out (see usePageHeader).
export const usePageHeaderStore = defineStore('pageHeader', () => {
  const eyebrow = ref<string | null>(null)
  const title = ref<string | null>(null)

  function set(next: { eyebrow?: string | null; title?: string | null }) {
    eyebrow.value = next.eyebrow ?? null
    title.value = next.title ?? null
  }

  function clear() {
    eyebrow.value = null
    title.value = null
  }

  return { eyebrow, title, set, clear }
})
